import * as React from "react";

import { Box, Card, CardContent } from "@mui/material";

const Deckboard = (props: React.PropsWithChildren<{}>) => {
  return (
    <Card
      variant="outlined"
      sx={{
        padding: "1rem 0 1rem 0",
        "& .MuiCardContent-root": {
          paddingTop: "0",
          "&:last-child": {
            paddingBottom: "0",
          },
        },
      }}
    >
      <CardContent>
        <Box
          sx={(theme) => ({
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gridGap: theme.spacing(2),
            "& .MuiButton-root": {
              width: "100%",
              aspectRatio: "1",
            },
          })}
        >
          {props.children}
        </Box>
      </CardContent>
    </Card>
  );
};

export default Deckboard;
